import * as React from "react";
import cx from "classnames";

import styles from "./back.module.css";

interface IProps {
  onClick: () => void;
  className?: string;
}

export default function BackButton({ onClick, className }: IProps) {
  return (
    <div className={cx(styles.back, className)} onClick={onClick}>
      <i className={styles.arrowPart} />
      <i className={styles.arrowPart} />
    </div>
  );
}
